import { BarChartLegend } from 'pages/Dashboard/components/BarChartLegend';
import { ChartContainer, StyledBarChart } from 'pages/Dashboard/components/styled';
import { VerticalScrollableBarChart } from 'pages/Dashboard/components/VerticalScrollableBarChart';
import { useMemo } from 'react';
import { Bar, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';
import { useThemeValues } from 'styles/theme';
import { KCFColor } from 'styles/themes/KCFColor';
import { ellipsize } from 'utils/string';

type LocationTicketStatus = {
    LocationId: string;
    LocationName: string;
    OpenCount: number;
    ClosedCount: number;
};

export function OpenVsClosedTickets({ data }: { data: LocationTicketStatus[] }) {
    const theme = useThemeValues();

    const chartData = useMemo(
        () =>
            data.map((location) => ({
                name: location.LocationName,
                Open: location.OpenCount,
                Closed: -location.ClosedCount,
            })),
        [data]
    );

    return (
        <ChartContainer style={{ minHeight: 0 }}>
            <VerticalScrollableBarChart
                xAxisHeight={30}
                dataLength={chartData.length}
                minBarHeight={42}
                legend={
                    <BarChartLegend
                        items={[
                            {
                                color: KCFColor.blue6,
                                label: 'Closed',
                            },
                            { color: KCFColor.blue4, label: 'Open' },
                        ]}
                    />
                }
            >
                {({ xAxisHeight }) => (
                    <StyledBarChart data={chartData} layout="vertical" stackOffset="sign">
                        <CartesianGrid
                            strokeDasharray="3 3"
                            stroke={theme.borderColor}
                            horizontal={false}
                        />
                        <XAxis
                            type="number"
                            tick={{ fill: theme.primaryText }}
                            height={xAxisHeight}
                            tickFormatter={(value) => Math.abs(value).toLocaleString()}
                        />
                        <YAxis
                            type="category"
                            dataKey="name"
                            tick={{ fill: theme.primaryText }}
                            width={110}
                            tickFormatter={(value) => ellipsize(24, value)}
                        />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: theme.backgroundColor,
                                border: `1px solid ${theme.borderColor}`,
                            }}
                            labelStyle={{ color: theme.primaryText }}
                            formatter={(value: number) =>
                                Math.abs(value).toLocaleString()
                            }
                        />
                        <Bar
                            dataKey="Closed"
                            stackId="status"
                            fill={KCFColor.blue6}
                            radius={[0, 5, 5, 0]}
                        />
                        <Bar
                            dataKey="Open"
                            stackId="status"
                            fill={KCFColor.blue4}
                            radius={[0, 5, 5, 0]}
                        />
                    </StyledBarChart>
                )}
            </VerticalScrollableBarChart>
        </ChartContainer>
    );
}
